import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Timer } from './Timer';
import { ArrowButtonStyled, ArrowDownIconStyled, ArrowUpIconStyled, BackdropTimer, BreakIconStyled, DescriptionRegister, PlayIconStyled, SendIconStyled, TitleQuiz, WrapperArrowButtonStyled, WrapperButtons, WrapperDescription, WrapperQuestions, WrapperQuiz} from '../views/Quiz.styled';
import {checkTaskListFn} from '../utils/checkTaskListFn';
import { DURATION } from '../utils/constants';
import {Button, Tooltip} from '@mui/material';
import { CloseQuizPopup } from './modals/CloseQuizPopup';
import ReactRouterPromptRaw from "react-router-prompt";
import { StartQuizPopup } from './modals/StartQuizPopup';
import { Question } from './Question';
import { ResultInfo } from './ResultInfo';
import { toast } from 'react-hot-toast';
import {TimerIcon} from './ResultInfo.styled';
import { MissingAnswersPopup } from './modals/MissingAnswersPopup';
import { findQuizById } from '../utils/findQuizById';
import { Helmet } from "react-helmet-async";
import { META_DATA } from "../utils/constants";
import { findMissingAnswers } from '../utils/findMissingAnswersFn';
import { handleScrollDown, handleScrollUp } from '../utils/helpers';


const ReactRouterPrompt = (ReactRouterPromptRaw).default? (ReactRouterPromptRaw).default:ReactRouterPromptRaw;


export const QuizNotRegister = () => {   
    const { id } = useParams();
    const navigate = useNavigate();
    
    const [arrQuestion, setArrQuestion] = useState([]);
    const [infoQuiz, setInfoQuiz] = useState({});
    const [responses, setResponses] = useState([]);
    const [result, setResult] = useState(null);
    const [isTimeFinish, setIsTimeFinish] = useState(false);
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [isOnBreakTimer, setIsOnBreakTimer] = useState(false);
    const [isOpenMissingPopup, setIsOpenMissingPopup] = useState(false);
    const [missingAnswerList, setMissingAnswerList] = useState(null);
    
    const { title, description, keywords } = META_DATA?.quiz;


    useEffect(() => {
        if (id) {        
            const quiz = findQuizById(id);
            if (!quiz) {
              navigate("/simulation");  
            }
            if (quiz?.tasks) {
                setArrQuestion(quiz.tasks.map(task=>({...task, taskPoint: 0})));
                setInfoQuiz({category: quiz?.category, year: quiz?.year})
            }           
            if (!localStorage.getItem(`timer-${id}`)) {
              setIsOpenPopup(true);  
            }            
      }  
    },[id])
   
    
    const handleAddAnswer = (answerId, answerNameKey) => {
            setResponses(prev => {
                const filtredAnswerList = prev.filter(({ _id }) => _id !== answerId);
                return ([...filtredAnswerList, { _id: answerId, answerNameKey }])
            });
    }

    const handleTimeUsed = (time) => {
        setResult(prev => ({...prev, timeUsed: time}));
    }

    const checkQuiz = () => {
        if (isOpenMissingPopup) {
            setIsOpenMissingPopup(false);            
        }
        const { taskListWithResult, quizResult } = checkTaskListFn(arrQuestion, responses);        
        setArrQuestion(taskListWithResult); 
        localStorage.clear(); 
        setResult({idQuiz: id,quizName: `${infoQuiz?.category} ${infoQuiz?.year}`,...quizResult});
        handleScrollUp(); 
    }

    const handleSubmit = (e) => {
        e.preventDefault(); 
        if (responses.length < arrQuestion.length) {            
            setMissingAnswerList(findMissingAnswers(arrQuestion, responses));            
            setIsOpenMissingPopup(true);
            return;
        }
        checkQuiz();
    }

    const handleTimeFinish = () => {
        setIsTimeFinish(true);
    }

    const handleToggleBreakTimer = () => {
        setIsOnBreakTimer(prev => !prev);
    }

     const handleClosePopup = () => {
        setIsOpenPopup(false);
    }

     const handleCloseMissingPopup = () => {
         setIsOpenMissingPopup(false);
    }


    useEffect(() => {
        if (responses.length === 0 && isTimeFinish) {          
            toast('Il tempo è scaduto! Non hai dato alcuna risposta.', {
                icon: <TimerIcon />, 
                duration: 3000,
            });            
            navigate('/');
            return;
        }
        if (isTimeFinish) {
            toast('Il tempo è scaduto!', {
                icon: <TimerIcon />,               
                style: { color: "#0b4a72" }
            });
            checkQuiz();
        }
    }, [isTimeFinish]);

    useEffect(() => {
        if (result) {
          localStorage.setItem('quizResult', JSON.stringify(result));  
        }
    },[result])


    return (
        <>
            <Helmet>
                <title>{infoQuiz.category && `${infoQuiz.category[0].toUpperCase()}${infoQuiz.category.slice(1)} ${infoQuiz?.year} - ${title}`}</title>
                <meta name="keywords" content={keywords} />
                <meta name="description" content={description} />
            </Helmet>

        <WrapperQuiz>               
                {infoQuiz?.year && infoQuiz?.category &&
                    <TitleQuiz>{infoQuiz.category} {infoQuiz.year}</TitleQuiz>}
                
             {arrQuestion.length > 0 &&
                <StartQuizPopup
                isOpenPopup={isOpenPopup && !localStorage.getItem(`timer-${id}`)}
                onClosePopup={handleClosePopup}                
                infoQuiz={infoQuiz}
                    />}
            
            <MissingAnswersPopup
                isOpenMissingPopup={isOpenMissingPopup}
                onSubmit={checkQuiz}
                onCloseMissingPopup={handleCloseMissingPopup}
                missingAnswerList={missingAnswerList}
                />


            <ReactRouterPrompt when={responses.length >= 1 && !(result?.points || result?.points === 0)}>
                {({ isActive, onConfirm, onCancel }) =>
                    isActive && (
                        <CloseQuizPopup open={isActive} onConfirm={onConfirm} onCancel={onCancel} />
                    )}
            </ReactRouterPrompt>    
            
            {arrQuestion.length > 0 && 
                <>                               
                {!isOpenPopup &&
                    <Timer time={ DURATION.TIMER_75 } id={id} onTimeFinish={handleTimeFinish} isOnBreakTimer={isOnBreakTimer} points={result?.points} onTimeUsed={handleTimeUsed} />}
                
                <BackdropTimer open={isOnBreakTimer}>
                    <Tooltip title="Fai ripartire il timer" placement="left-start">
                    <ArrowButtonStyled aria-label="Play timer" onClick={handleToggleBreakTimer}>
                        <PlayIconStyled/>
                        </ArrowButtonStyled>
                    </Tooltip>                  
                </BackdropTimer>
                
                    {result && <ResultInfo result={result} />}
                    

                {arrQuestion.length > 0/*  && !result  */&&
                    <WrapperQuestions >
                    {arrQuestion.map(({ question, _id, answers, img, taskPoint, disabled = false }, index) => (
                        <Question
                            key={_id}
                            _id={_id}
                            question={question}
                            answers={answers}
                            onAddAnswer={handleAddAnswer}
                            img={img}
                            taskPoint={taskPoint}
                            disabled={disabled}
                            index={index}
                        />))}
                        </WrapperQuestions>}
                    {/* {!result &&  */}
                    <WrapperArrowButtonStyled>
                        {((!result?.points || !result?.points === 0) && !isTimeFinish) && 
                        <Tooltip title="Metti in pausa il timer" placement="left-start">
                            <ArrowButtonStyled aria-label="Break timer" onClick={handleToggleBreakTimer}>
                                <BreakIconStyled />
                            </ArrowButtonStyled>
                        </Tooltip>}
                    
                    <ArrowButtonStyled aria-label="Scroll to top" onClick={handleScrollUp}>
                        <ArrowUpIconStyled/>
                </ArrowButtonStyled>
                <ArrowButtonStyled aria-label="Scroll to down" onClick={handleScrollDown}>
                        <ArrowDownIconStyled/>
                    </ArrowButtonStyled>                    
                </WrapperArrowButtonStyled>
                    {/* } */}
                    
                {result === null && responses.length > 0 && <Button variant="contained" onClick={handleSubmit} >                            
                            invia
                            <SendIconStyled/>
                    </Button>}
                    {result &&
                        <WrapperDescription>
                        {/* <DescriptionRegister>
                            Per vedere il risultato dettagliato del quiz, con le risposte giuste e sbagliate,
                            registrati ora. 
                        </DescriptionRegister> */}
                        <DescriptionRegister>
                            Registrati ora e potrai salvare tutti i tuoi risultati, consultare le statistiche e
                            partecipare alle classroom per un'esperienza di apprendimento completa.
                        </DescriptionRegister>
                        </WrapperDescription>
                    }
                    {result &&
                        <WrapperButtons>
                            <Button component={Link} to='/register' variant="contained" color='benjamin'>registrati</Button>                            
                            <Button component={Link} to="/simulation" variant="outlined">continua allenamento</Button>                           
                    </WrapperButtons>}
                  
            </>
            }
            </WrapperQuiz>
            </>
    )
}
